const useFormServerErrors = () => {

    const createKey = (string: string) => {
        return string.charAt(0).toLowerCase() + string.slice(1);
    };

    const getErrorsFromServer = (response: any, initialDataFrom: any) => {
        const dataReturn = {};
        const keysFrom = Object.keys(initialDataFrom);
        for (let index = 0; index < response.Messages.length; index++) {
            const key = createKey(String(response.Messages[index].PropertyName).replace('Model.', ''));
            if (keysFrom.indexOf(key) !== -1) {
                Object.assign(dataReturn, { [key]: response.Messages[index].ErrorMessage });
            }
        }
        return dataReturn;
    };

    const getCustomError = (response: any, initialDataFrom: any): string[] => {
        const messages = [];
        const keysFrom = Object.keys(initialDataFrom);
        for (let index = 0; index < response.Messages.length; index++) {
            const key = createKey(String(response.Messages[index].PropertyName).replace('Model.', ''));
            if (keysFrom.indexOf(key) === -1) {
                messages.push(response.Messages[index].ErrorMessage);
            }
        }
        return messages;
    };

    const getCustomErrorProductReservation = (response: any): string[] => {
        const errors = [];
        for (let index = 0; index < response.errors.length; index++) {
            const key = String(response.errors[index]).replace('Model.', '');
            errors.push(key);
        }
        return errors;
    };



    const getCustomErrorMessage = (response: any, initialDataFrom: any) => {
        var messages = getCustomError(response, initialDataFrom)
        return mapErrorsFromString(messages);
    };

    const getCustomErrorMessageProductReservation = (response: any) => {
        var messages = getCustomErrorProductReservation(response)
        return mapErrorsFromString(messages);
    };

    const getErrorMsg = (response: any): string => {
        return mapErrorsFromString(getErrorMessages(response));
    };

    const getErrorMessages = (response: any): string[] => {
        return  (response.Messages as any[]).map(x => x.ErrorMessage);
    };

    const mapErrorsFromString = (messages: string[]) => {
        return messages.join('<br />')
    };

    const hasError = (response: any): boolean => {
        return response.hasOwnProperty('Errors');
    };

    const getFullErrorsFromServer = (response: any, initialDataForm: any) => {
        return {
            customError: getCustomErrorMessage(response, initialDataForm),
            fieldsErrors: getErrorsFromServer(response, initialDataForm)
        };
    }
    
    return { getErrorsFromServer, getCustomError, getErrorMsg, hasError, getFullErrorsFromServer, getErrorMessages, getCustomErrorMessageProductReservation };
};

export default useFormServerErrors;
